<nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom" id="nav1"
  [ngStyle]="{'direction': this.apiService.currentDirection === 'rtl'? 'rtl': 'ltr', 'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">
  <a class="navbar-brand" [routerLink]="['/']">
    <!--    {{'Alobodo'|translate}}-->
    <img src="../../../assets/img/Alobodo.png" width="45px" />

  </a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarColor03"
    aria-controls="navbarColor03" aria-expanded="false" aria-label="Toggle navigation"
    (click)="isCollapsed = !isCollapsed">
    <span class="navbar-toggler-icon"></span>
  </button>
  <!--  [ngClass]="this.apiService.currentDirection === 'rtl'? 'ml-auto' : 'mr-auto'"-->
  <div class="collapse navbar-collapse" id="navbarColor03" [ngbCollapse]="isCollapsed">
    <ul class="navbar-nav " [ngClass]="this.apiService.currentDirection === 'rtl'? 'rtl' : 'ltr'">
      <li class="nav-item active">
        <a class="nav-link" [routerLink]="['/']" (click)="isCollapsed = !isCollapsed">{{'Home'|translate}}</a>
      </li>
      <li class="nav-item ">
        <a class="nav-link"
          (click)="ScrollIntoView('#footer');ScrollIntoView('#download');isCollapsed = !isCollapsed">{{'Download'|translate}}
          <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item" *ngIf="this.router.url === '/'">
        <a class="nav-link"
          (click)="ScrollIntoView('#features');isCollapsed = !isCollapsed">{{'Features'|translate}}</a>
      </li>
      <li class="nav-item" *ngIf="this.router.url === '/'">
        <a class="nav-link" (click)="ScrollIntoView('#about');isCollapsed = !isCollapsed">{{'AboutUs'|translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" (click)="ScrollIntoView('#footer');isCollapsed = !isCollapsed">{{'ContactUs'|translate}}</a>
      </li>
    </ul>

    <ul class="nav navbar-nav" [ngClass]="this.apiService.currentDirection === 'rtl'? 'mr-auto' : 'ml-auto'">
      <li class="nav-item" *ngIf="this.apiService.currentDirection === 'rtl'">
        <a class="nav-link mx-3" (click)="changeLanguage('en-us')">
          <i class="fa fa-globe fa-lg"></i> En
        </a>
      </li>
      <li class="nav-item" *ngIf="this.apiService.currentDirection === 'ltr'">
        <a class="nav-link mx-3" (click)="changeLanguage('fa-ir')" style="font-family: vazir-Light!important">
          <i class="fa fa-globe fa-lg"></i> فا
        </a>
      </li>
    </ul>

    <form class="form-inline mx-3 my-2 my-lg-0">
      <!--      <input class="form-control mr-sm-2" type="text" placeholder="Search">-->
      <!--      <button class="btn btn-secondary my-2 my-sm-0" type="submit">Search</button>-->
      <a class="nav-class mx-1" href="https://web.alobodo.com/" target="_blank">
      <button class="btn btn-primary custom-btn">
        <a class="nav-class mx-1" href="https://web.alobodo.com/" target="_blank">
          {{'SignIn'|translate}} / {{'LogIn'|translate}}
        </a>
      </button>
      </a>


      
        <button class="btn custom-btn">
          <a class="nav-class mx-1" [routerLink]="['/reg']" (click)="isCollapsed = !isCollapsed">
          {{'JoinAsAPro'|translate}}
          </a>
        </button>
      
    </form>
  </div>
</nav>